"use client";

import React from "react";
import { Magnet, Clock, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const principles = [{
  icon: Magnet,
  title: "Designed in Quebec",
  description: "Born in the heart of Montreal, blending French chic with a playful Kawaii soul."
}, {
  icon: Clock,
  title: "Small Batch Printing",
  description: "Crafted slowly on boutique 3D printers to ensure every click and pop is perfect."
}, {
  icon: Zap,
  title: "Boutique Collectibles",
  description: "Limited-edition designer toys made for your favorite daily obsessions and fidgets."
}];
export default function WarumFunktioniertDas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222309" id="the-boutique-philosophy" className="bg-background text-foreground">
      <div className="bg-secondary/20 py-32 px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-default font-bold mb-4 tracking-tight text-foreground">
              The Boutique Philosophy
            </h2>
            <p className="text-muted-foreground font-default max-w-2xl mx-auto text-xl">
              Tiny toys, big serotonin. Every Petit Pop is a piece of collectible art.
            </p>
          </div>

          <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {principles.map((item, i) => {
            const Icon = item.icon;
            return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                  <div className="w-24 h-24 rounded-4xl bg-card border border-border/50 flex items-center justify-center text-primary mb-8 shadow-md transition-transform duration-500 group-hover:scale-110 group-hover:shadow-xl group-hover:border-primary/30">
                    <Icon className="w-12 h-12" strokeWidth={1.5} />
                  </div>
                  <h3 className="text-2xl font-default font-semibold tracking-tight mb-3 text-foreground">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground font-default leading-relaxed max-w-[280px] text-lg">
                    {item.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}